import { render } from "./DashboardPageHeader.vue?vue&type=template&id=74c6b141&scoped=true"
import script from "./DashboardPageHeader.vue?vue&type=script&lang=js"
export * from "./DashboardPageHeader.vue?vue&type=script&lang=js"

import "./DashboardPageHeader.vue?vue&type=style&index=0&id=74c6b141&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c6b141"]])

export default __exports__